import React from 'react';

const NewsletterSuccess = () => (
  <p>Success! You&apos;ve been subscribed to our newsletter.</p>
);

export default NewsletterSuccess;
